import { css } from "@emotion/react";
import { ui } from "@joinlean/utils-react";

export const div = css`
  position: relative;
  width: 100%;
  height: 100%;
  ${ui.flexCenter()};
`;
